// @ts-nocheck

import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';

export const THIRD_PARTY_PROVIDER_SET_SELECTED = 'THIRD_PARTY_PROVIDER_SET_SELECTED';

export function thirdPartyProviderSetSelected(espSelected) {
  return {
    type: THIRD_PARTY_PROVIDER_SET_SELECTED,
    espSelected,
  };
}

const ThirdPartyProviderGet = new ReduxAsyncAction('THIRD_PARTY_PROVIDER_GET');
ThirdPartyProviderGet.registerRequest(function () {
  return dash_api.get(`/v1/app/third-party-link-provider-configuration`).then(({ data }) => data);
});
export const loadThirdPartyProviderConfig = ThirdPartyProviderGet.request;
export const THIRD_PARTY_PROVIDER_GET = ThirdPartyProviderGet.constants;

const ThirdPartyProviderPut = new ReduxAsyncAction('THIRD_PARTY_PROVIDER_PUT');
ThirdPartyProviderPut.registerRequest(function (provider_id, body) {
  return dash_api.put(`/v1/app/third-party-link-provider-configuration/${provider_id}`, body).then(({ data }) => {
    return { [provider_id]: data };
  });
});
export const updateThirdPartyProviderConfig = ThirdPartyProviderPut.request;
export const THIRD_PARTY_PROVIDER_PUT = ThirdPartyProviderPut.constants;

const ThirdPartyProviderPatch = new ReduxAsyncAction('THIRD_PARTY_PROVIDER_PATCH');
ThirdPartyProviderPatch.registerRequest(function (provider_id, body) {
  return dash_api.patch(`/v1/app/third-party-link-provider-configuration/${provider_id}`, body).then(({ data }) => {
    return { [provider_id]: data };
  });
});
export const partialUpdateThirdPartyProviderConfig = ThirdPartyProviderPatch.request;
export const THIRD_PARTY_PROVIDER_PATCH = ThirdPartyProviderPatch.constants;
